export interface LangSetting {
  defaultLanguage: string;
  supportedAppLanguages: string[];
  supportedDocLanguages: string[];
}

/**
 * Language codes
 */
export enum Lang {
  CZ = 'cz',
  EN = 'en',
}

/**
 * Translate language codes
 */
export enum LangTranslated {
  CZ = 'lang.czech',
  EN = 'lang.english',
}
